/* unplugin-vue-components disabled */import { render } from "./SharePopup.vue?vue&type=template&id=15f581c8&scoped=true"
import script from "./SharePopup.vue?vue&type=script&lang=js"
export * from "./SharePopup.vue?vue&type=script&lang=js"

import "./SharePopup.vue?vue&type=style&index=0&id=15f581c8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f581c8"]])

export default __exports__